import "./index.scss";

import { Box } from "@mui/material";
import { TMemberDetails } from "models/member";
import { useMemo } from "react";
import { useAppSelector } from "redux/hooks";

import ContactsSection from "./ContactsSection";
import ExerciseHealthSection from "./ExerciseHealthSection";
import GroupSection from "./GroupSection";
import InterestsSection from "./InterestsSection";
import MembershipSection from "./MembershipSection";
import PersonalInfoSection from "./PersonalInfoSection";
import StatusSection from "./StatusSection";
import SystemOptionSection from "./SystemOptionSection";
import TrainerSection from "./TrainerSection";

export default function PersonalDetails(props: { member: TMemberDetails; editCallback: Function }) {
  const { member, editCallback } = props;
  const { settings } = useAppSelector((state) => state.facilityOptions);

  const canShowExerciseReadiness = useMemo(() => {
    return !!settings?.OPTIONS?.exercise_readiness_tab_on?.value;
  }, [settings]);

  const canShowHealthCondition = useMemo(() => {
    return !!settings?.OPTIONS?.health_conditions_tab_on?.value;
  }, [settings]);

  const canShowHealthInterests = useMemo(() => {
    return !!settings?.OPTIONS?.specify_interests_tab_on?.value;
  }, [settings]);

  const callback = (v: string) => {
    editCallback(v);
  };

  return (
    <Box className="personal-details-container">
      <Box flex={2} className="personal-details-container__first-inner-div">
        <PersonalInfoSection member={member} editCallback={() => callback("primary_details")} />
        <ExerciseHealthSection
          member={member}
          canShowExerciseReadiness={canShowExerciseReadiness}
          canShowHealthCondition={canShowHealthCondition}
          editCallback={callback}
        />
        <ContactsSection member={member} editCallback={() => callback("contacts")} />
        {canShowHealthInterests && (
          <InterestsSection member={member} editCallback={() => callback("interests")} />
        )}
      </Box>
      <Box flex={1} sx={{ background: "#EBF7F6" }} p={3}>
        <MembershipSection member={member} editCallback={() => callback("primary_details")} />

        <TrainerSection member={member} editCallback={() => callback("primary_details")} />

        <StatusSection member={member} editCallback={() => callback("primary_details")} />

        <SystemOptionSection member={member} editCallback={() => callback("primary_details")} />

        <GroupSection member={member} />
      </Box>
    </Box>
  );
}
